const fb = require("../firebase.js");

export default {
  namespaced: true,
  state: {
    comment: {},
    commentPending: false,
    commentError: null,
    comments: [],
    commentsPending: false,
    commentsError: null,
  },
  mutations: {
    setComment (state, value) {
      state.comment = value
    },
    createComment (state, value) {
      state.comments.unshift(value)
    },
    deleteComment (state, value) {
      state.comments = state.comments.filter(function (p) {
        return p.id !== value.id;
      });
    },
    setCommentPending (state, value) {
      state.commentPending = value
    },
    setCommentError (state, value) {
      state.commentError = value
    },
    setComments (state, value) {
      state.comments = value
    },
    setCommentsPending (state, value) {
      state.commentsPending = value
    },
    setCommentsError (state, value) {
      state.commentsError = value
    },
  },
  actions: {
    getComments({ commit }, payload){
      commit('setComments', [])
      commit('setCommentsPending', true)
      fb.db.collection("comments").doc(payload.gardenId).collection('comments').doc(payload.itemId).collection('comments').orderBy("createdAt", "desc").limit(10)
        .get()
        .then((querySnapshot) => {
          let comments = []
          querySnapshot.forEach((doc) => {
            comments.push({ id: doc.id, ...doc.data() })
          });
          commit('setComments', comments)
          commit('setCommentsPending', false)
        })
        .catch((error) => {
          commit('setCommentsPending', false)
          commit('setCommentsError', error)
        })
    },
    createComment({commit}, payload){
      let newComment = { createdAt: fb.firebase.firestore.Timestamp.now(), ...payload.comment }
      commit('setCommentPending', true)
      fb.db.collection("comments").doc(payload.gardenId).collection('comments').doc(payload.itemId).collection('comments').add(newComment).then(data =>{
          commit("createComment", { id: data.id, ...newComment })
          commit('setCommentPending', false)
        })
        .catch((error) => {
          commit('setCommentPending', false)
          commit('setCommentError', error)
        })
    },
    deleteComment ({state, commit}, payload) {
      commit("deleteComment", payload.comment)
      fb.db.collection("comments").doc(payload.gardenId).collection('comments').doc(payload.itemId).collection('comments').doc(payload.comment.id).delete()
    },
    uploadCommentPicture({ rootState, dispatch }, payload) {
      let pictureName = fb.firebase.auth().currentUser.uid + "_" + fb.firebase.firestore.Timestamp.now()
      var uploadTask = fb.firebase
        .storage()
        .ref("/commentPictures")
        .child(pictureName)
        .putString(payload.dataurl, "data_url");
      uploadTask.on(
        "state_changed",
        function(snapshot) {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          // console.log('Upload is ' + progress + '% done');
          switch (snapshot.state) {
            case fb.firebase.storage.TaskState.PAUSED: // or 'paused'
              // console.log("Upload is paused");
              break;
            case fb.firebase.storage.TaskState.RUNNING: // or 'running'
              // console.log("Upload is running");
              break;
          }
        },
        function(error) {
          // Handle unsuccessful uploads
        },
        function() {
          uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {

            let comment = {
              createdAt: fb.firebase.firestore.Timestamp.now(),
              userId: fb.firebase.auth().currentUser.uid,
              pictureUrl: downloadURL
            };
      
            if (rootState.self.self.profilePictureUrl)
              comment.profilePictureUrl = rootState.self.self.profilePictureUrl;
            if (rootState.self.self.nickname) comment.userNickname = rootState.self.self.nickname;

            dispatch("createComment", {
              gardenId: payload.gardenId,
              itemId: payload.itemId,
              comment,
            });           
          });
        }
      );
    },
  }
}